import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setLoading } from '../global';
import { bearerAuth } from '../auth';

export interface BuildDemoCredentialsRequest {
    pid: Record<string, unknown>;
    kvkNumber: string;
    companyName: string;
    address: string;
}

export const createDemoCredentials = createAsyncThunk<
    string[],
    { jwtToken: string | undefined; request: BuildDemoCredentialsRequest }
>(
    'DemoCredential/create',
    ({ jwtToken, request }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = { headers: { 'Authorization': bearerAuth(jwtToken) } };
        return axios
            .post('/manage/demoCredential/create', request, config)
            .then(response => response.data as string[])
            .finally(() => thunkAPI.dispatch(setLoading(false)));
    },
);
